<template>
  <div class="tabs__list">
    <div
      v-for="index in tabsLength"
      :key="index"
      :class="tabsClass(index)"
      :title="getTabsTitle(index)"
      @click="tabsChange(index)"
    ></div>
  </div>
</template>
<script>
export default {
  name: "TabsList",
  props: {
    tabsLength: Number,
    activeIndex: Number,
    showShopTitles: Boolean,
  },

  methods: {
    getTabsTitle(index) {
      if (!this.showShopTitles) return;
      return this.$t(`shop.list.box_${index - 1}`);
    },
    tabsClass(index) {
      return ["tabs__item", { active: index === this.activeIndex }];
    },
    tabsChange(index) {
      this.$emit("changeTab", index);
    },
  },
};
</script>
